import React, { useEffect, useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../../components";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { HomeModalAd } from "../../templates/advertiesments";

const Index = (props) => {
  const { isOpenAd } = useSelector(({ consoleReducer }) => consoleReducer);

  const dispatch = useDispatch();

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenAd ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-ad-wrapper modal-container w-365  d-flex flex-column animate__animated  ${
          isOpenAd ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="home-ad_view-modal-wrapper">
          {/* <img src={""} alt="Home-Advertisement" className={"had__img"} /> */}

          <HomeModalAd />

          <div className={"had__content"}>
            <div className="had-logo">
              <img
                src={require("../../../assets/img/dfyBest.png")}
                alt="Logo"
              />
            </div>
            <div className="had-title-wrapper ">
              <div className="had-title">difybest</div>
              <div className="had-subtitle">
                Designing the Future of Your Brand
              </div>
            </div>
            <Button
              data={{
                btnName: "Visit Now",
                buttonType: "primary",
                buttonSize: "xs x",
                isLoading: false,
              }}
              onClick={async (e) => {
                window.open("https://difynbest.com/index.html");
              }}
            />
          </div>
        </div>

        {/* <div className={"nvmw_button-wrapper"}>
          <Button
            data={{
              btnName: "CLOSE",
              buttonType: "primary",
              buttonSize: "sm x",
              isLoading: false,
            }}
            onClick={async (e) => {
              dispatch(closeNewsViewModal());
            }}
          />
          <Button
            data={{
              btnName:
                selectNews?.status === "deactivated"
                  ? "ACTIVATE"
                  : "DEACTIVATE",
              buttonType: "primary",
              buttonSize: "sm x",
              isLoading: false,
            }}
            onClick={async (e) => {
              e.preventDefault();
              await onClickDeactive(e);
            }}
          />
        </div> */}
      </div>
    </>
  );
};
export default withRouter(Index);
